module.exports = __webpack_public_path__ + "img/chevron-right-solid.60a4b01c.svg";